import { type ChangeEvent } from 'react'
import { useController, useFormContext } from 'react-hook-form'

import { TextArea, TextAreaProps } from '@/components/ui/text-area'

export type TextAreaFormFieldProps = TextAreaProps & {
  name: string
}

export const TextAreaFormField = ({
  name,
  rows = 5,
  maxLength = 200,
  ...props
}: TextAreaFormFieldProps) => {
  const { field, fieldState } = useController({ name })
  const { trigger } = useFormContext()

  const handleChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
    field.onChange(e)
    // Character limit is validated out-of-scope of the onTouched flow: typing
    // stays unlimited, but the error shows immediately once the limit is passed.
    if (maxLength && e.target.value.length > maxLength) trigger(name)
  }

  return (
    <TextArea
      ref={field.ref}
      error={fieldState.error?.message}
      name={field.name}
      value={field.value ?? ''}
      characterLimit={maxLength}
      rows={rows}
      onBlur={field.onBlur}
      onChange={handleChange}
      {...props}
    />
  )
}
